import * as React from 'react';
import { ModalContextProps } from '../types';

export const ModalContext = React.createContext<ModalContextProps>(null);
export const ModalContextProvider = ModalContext.Provider;

export function useModal() {
  const ctx = React.useContext(ModalContext);

  if (!ctx) {
    throw new Error('useModal hook was called outside of context, wrap your app with ModalProvider component');
  }

  return ctx;
}
